import get from "get-js";
import { useEffect, useState } from "react";

export const useHere = () => {
  const [hereLoaded, setHereLoaded] = useState(false);

  useEffect(() => {
    get([
      "https://js.api.here.com/v3/3.1/mapsjs-core.js",
      "https://js.api.here.com/v3/3.1/mapsjs-service.js",
      "https://js.api.here.com/v3/3.1/mapsjs-ui.js",
      "https://js.api.here.com/v3/3.1/mapsjs-mapevents.js",
    ]).then(() => {
      setHereLoaded(true);
    });
  }, [setHereLoaded]);

  return hereLoaded;
};
